export const DEFAULT_APP_VAT_PERCENTAGE = 15;
